import React from 'react';
import { LegalLayout } from '../components/legal/LegalLayout';
import { useLanguage } from '../contexts/LanguageContext';
export function TermsAndConditions() {
  const {
    t
  } = useLanguage();
  const sections = t('legal.terms.sections') || [];
  return <LegalLayout title={t('legal.terms.title')} lastUpdated="October 24, 2024" data-id="element-229">
      <p data-id="element-230">{t('legal.terms.intro')}</p>

      {sections.map((section: any, index: number) => <div key={index} data-id="element-231">
          <h2 data-id="element-232">{section.heading}</h2>
          {section.paragraphs.map((p: string, pIndex: number) => <p key={pIndex} data-id="element-233">{p}</p>)}
          {section.list && <ul data-id="element-234">
              {section.list.map((item: string, lIndex: number) => <li key={lIndex} data-id="element-235">{item}</li>)}
            </ul>}
        </div>)}
    </LegalLayout>;
}